import { FetchDeepArchiveRestoreRequestsSortTypes } from './deepArchiveRestoreRequestsTypes';

export const INITIAL_DEEP_ARCHIVE_RESTORE_REQUESTS_FILTERS = {};
export const INITIAL_DEEP_ARCHIVE_RESTORE_REQUESTS_PAGE = 1;
export const INITIAL_DEEP_ARCHIVE_RESTORE_REQUESTS_SORT = [
  FetchDeepArchiveRestoreRequestsSortTypes.CREATED_AT_DESC
];
export const INITIAL_DEEP_ARCHIVE_RESTORE_REQUESTS_LIMIT = 24;
